module.exports = __webpack_public_path__ + "static/media/time.5535a28a.svg";